import React, { useState, useEffect, useContext } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Box, Button, Typography } from '@mui/material';
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import swal from "sweetalert";
import ActionDropdownVendor from "./ActionDropdownVendor";

const Vendors = () => {
  const { signOut } = useContext(UserContext);
  const [userType, setUserType] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorData] = useState([]);
  const [token, setToken] = useState("");

 useEffect(() => {
  const tokenResponse = getCurrentToken();

  if (!tokenResponse) {
    navigate("/login");
  } else {
    const userToken = tokenResponse.Data.Token;
    const userType = tokenResponse.Data.UserType;

    setToken(userToken);
    setUserType(userType);

    // ✅ Check permission after setting userType
    if (userType !== 1 && userType !== 2) {
      swal("Unauthorized", "You are not authorized to access this page.", "warning")
        .then(() => {
          navigate("/"); // or "/unauthorized"
        });
      return;
    }

    fetchVendorData(userToken);
  }
}, []);



  const approveVendor = async (VendorId) => {
    try {
      const response = await requests.post(`/approvevendorbyId?ID=${VendorId}`);
      if (response?.ResponseCode === 1) {
        swal("Success", "Vendor approved successfully.", "success");
        fetchVendorData(token);
      } else {
        swal("Failed", response?.ResponseMessage, "error");
      }
    } catch (error) {
      console.error("Approval error:", error);
      swal("Error", "An error occurred during approval.", "error");
    }
  };

  const fetchVendorData = async (userToken) => {
    try {
      const response = await requests.get("/getallVendors");
      if (response?.Data) {
        setVendorData(response.Data || []);
      } else {
        console.error("Error fetching vendors:", response.ResponseMessage);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
        accessorKey: 'ID',
        header: 'ID',
      },
    {
      accessorKey: 'Name',
      header: 'Business Name',
    },
   
    {
      accessorKey: 'PhoneNumber',
      header: 'Phone No',
    },
    {
      accessorKey: 'IsApproved',
      header: 'Approved',
      Cell: ({ cell }) => cell.getValue() ? 'Yes' : 'No',
    },
    {
      accessorKey: 'CanDeliver',
      header: 'Can Deliver',
      Cell: ({ cell }) => cell.getValue() ? 'Yes' : 'No',
    },
    {
      accessorKey: 'ID',
      header: 'Actions',
      Cell: ({ row }) => (
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={() => approveVendor(row.original.ID)}
        >
          Approve
        </Button>
      ),
    },
     {
      header: "Update Status",
      accessorKey: "actions",
      Cell: ({ row }) => <ActionDropdownVendor orderId={row.original.ID} onStatusUpdated={fetchVendorData}/>,
    },
  ];

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <>

    <Box className="container ">
      <Box mt={3} p={2} borderRadius={2} boxShadow={4} border="1px solid #ccc">
        <MaterialReactTable
          columns={columns}
          data={vendorData}
          enablePagination
          enableRowHover
          enableColumnResizing
          enableSorting
          muiTableContainerProps={{ sx: { maxHeight: 600 } }}
          muiTableBodyCellProps={{ sx: { fontSize: '14px' } }}
        />
      </Box>
    </Box>
   
    </>
  );
};

export default Vendors;